// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".molecule-project-portfolio[data-v-3382b942]{display:flex;flex:100%;flex-direction:column;height:100%}@media only screen and (max-width:900px){.molecule-project-portfolio[data-v-3382b942]{display:block;overflow:hidden;overflow-x:auto;white-space:nowrap;width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
